import React from 'react';

import { AnalysesContext } from './context';
import { AnalysesContextTypes } from './types';

export const useAnalysesContext = <T extends string, TResource = any>(): AnalysesContextTypes<T, TResource> => {
  const context = React.useContext(AnalysesContext);
  if (!context) {
    // During hot reload, context might be temporarily unavailable
    // Check if we're in development mode and provide a more helpful error
    if (process.env.NODE_ENV === 'development') {
      console.error('useAnalysesContext: Context not found. This might be a hot reload issue.');
    }
    throw new Error('useAnalysesContext must be used within an AnalysesContextProvider');
  }
  return context as AnalysesContextTypes<T, TResource>;
};
